import React from 'react';
import { Routes, Route } from 'react-router-dom';

// pages
import Summary from './Summary';

function SummaryRouter() {
  return (
    <Routes>
      <Route path="summary" element={<Summary />} />
    </Routes>
  );
}

export default SummaryRouter;
